import React from 'react';

export interface ErrorMessageContextType {
  messages?: Array<string>;
  displayError(message: string): void;
  clearMessages(): void;
}

export default React.createContext<ErrorMessageContextType>({
  displayError: undefined, clearMessages: undefined,
});
